import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, ArrowRight } from 'lucide-react';
import { companyInfo } from '../mockData';
import { UfuklarSignature } from './UfuklarSignature';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#8AC73E] via-[#4A7C3A] to-[#8AC73E]"></div>
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 50px, rgba(255,255,255,.03) 50px, rgba(255,255,255,.03) 100px)' }}></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6 flex items-center justify-start">
              <img
                src="/logo-ortadogu-ziraat.svg"
                alt="Ortadoğu Ziraat A.Ş."
                className="h-16 w-auto"
                style={{ backgroundColor: 'transparent' }}
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              GAP bölgesinin lider tohum ve tarımsal girdi şirketi. Tohumdan hasada güvenin adresi.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/people/Ortadoğu-Ziraat-AŞ/61559498566555/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#8AC73E] flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://x.com/ortadoguziraat"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#8AC73E] flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://www.instagram.com/ortadoguziraat"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#8AC73E] flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/ortadogu-ziraat-7b05311ba"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#8AC73E] flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Hızlı Erişim</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/hakkimizda" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Hakkımızda</span>
                </Link>
              </li>
              <li>
                <Link to="/sirketlerimiz" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Şirketlerimiz</span>
                </Link>
              </li>
              <li>
                <Link to="/tohumculuk" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Tohumculuk</span>
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Blog</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Şirketlerimiz */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Şirketlerimiz</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sirketlerimiz#ortadogu-seed" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Ortadoğu Seed</span>
                </Link>
              </li>
              <li>
                <Link to="/sirketlerimiz/akova-tarim" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Akova Tarım</span>
                </Link>
              </li>
              <li>
                <Link to="/sirketlerimiz/akova-pamuk" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Akova Pamuk</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Kurumsal - YENİ */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Kurumsal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sss" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>SSS</span>
                </Link>
              </li>
              <li>
                <Link to="/sertifikalar" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Sertifikalar</span>
                </Link>
              </li>
              <li>
                <Link to="/gizlilik" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Gizlilik Politikası</span>
                </Link>
              </li>
              <li>
                <Link to="/kullanim" className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm flex items-center space-x-2 group">
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  <span>Kullanım Şartları</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-[#8AC73E]" />
                <span className="text-gray-300 text-sm leading-relaxed">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="flex-shrink-0 text-[#8AC73E]" />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0 text-[#8AC73E]" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-300 hover:text-[#8AC73E] transition-colors text-sm break-all">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} <span className="text-white font-semibold">{companyInfo.name}</span> Tüm hakları saklıdır.
            </p>
            <div className="flex flex-col items-center gap-3 text-gray-400 text-sm sm:flex-row sm:gap-6">
              <span>Ortadoğu Ziraat A.Ş.</span>
              <UfuklarSignature surface="dark" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
